import React, { useRef } from "react";
import { useSelector } from "react-redux";

function uuidV4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const random = (Math.random() * 16) | 0;
    const r = random;
    const nfc = r & 0x3;
    const v = c === "x" ? r : nfc | 0x8;
    return v.toString(16);
  });
}

const WithLoader = function (ComposedComponent, Loader, loadingIdArray) {
  function LoadingComponent(props) {
    const loadingIdArrayRef = useRef(null);
    if (!loadingIdArrayRef.current) {
      const loadingId = uuidV4();
      loadingIdArrayRef.current = loadingIdArray ? [loadingId, ...loadingIdArray] : [loadingId];
    }

    const loading = useSelector((state) => state.withLoader);

    let loadingObject;
    loadingIdArrayRef.current.forEach((id) => {
      const loadObj = loading[id];
      if ((loadObj && loadObj.isLoading) || (loadObj && loadObj.hasErrored)) {
        loadingObject = loadObj;
      }
    });

    const isLoading = !!(loadingObject && loadingObject.isLoading);
    const hasErrored = !!(loadingObject && loadingObject.hasErrored);

    return (
      <>
        {hasErrored && (
          <Loader
            loadingText={
              <>
                {loadingObject?.errorMessage || "An error has occurred. Please refresh the page."}
                <button className="btn-link" onClick={() => window.location.reload()}>
                  {" "}
                  Or Click Here.
                </button>
              </>
            }
          />
        )}
        {isLoading && <Loader loadingText={loadingObject ? loadingObject.text : "Loading..."} />}
        <ComposedComponent {...props} />
      </>
    );
  }

  return LoadingComponent;
};

export default WithLoader;
